module.exports = __webpack_public_path__ + "media/reportAssets/themes-1d6050e2.png";